import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    event.preventDefault()

    const modalId = event.currentTarget.dataset.salaryCoverageModalId
    if (!modalId) return

    const modal = document.getElementById(modalId)
    if (!modal) return

    modal.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event) event.preventDefault()

    const modal = event.currentTarget.closest("[data-salary-coverage-modal]")
    if (!modal) return

    modal.classList.add("hidden")
    document.body.style.overflow = ""
  }
}
